export function getServerUrl() {
  //  return "http://localhost:2000"
 return "http://alexov.ru/"
}



// WEBPACK FOOTER //
// ./src/globalConfig.js